var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#F0F3F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 6V18H18V6H6Z",
    fill: "#1C8FF8",
    fillOpacity: 0.338428
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2939 8.3999C16.2939 9.44306 16.2035 13.5569 16.1464 16.0484C16.1215 17.134 15.2341 17.9998 14.1481 17.9998H10.0963C9.00738 17.9998 8.11857 17.1287 8.09669 16.04L7.94312 8.3999",
    stroke: "#FF754C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 8.3999H7.94297H17.4867",
    stroke: "#FF754C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73242 8.39997V7.19998C9.73242 6.53725 10.2665 6 10.9254 6H13.3113C13.9702 6 14.5043 6.53725 14.5043 7.19998V8.39997",
    stroke: "#FF754C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9255 11.4004V15.0003",
    stroke: "#FF754C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3113 11.4004V15.0003",
    stroke: "#FF754C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash2);
export default __webpack_public_path__ + "static/media/trash2.b8f6e06fc07d9a41c2aca6d966655610.svg";
export { ForwardRef as ReactComponent };